// Sugalarm — /api/push/native wrappers (cycle 28).

import { request } from "../lib/apiClient";
import type { ApiResult } from "../lib/types";

export type NativePushPlatform = "ios" | "android";

export interface NativePushToken {
  id: string;
  platform: NativePushPlatform;
  bundle_id: string;
  device_id: string | null;
  user_agent: string | null;
  created_at: string;
  last_success_at: string | null;
  last_failure_at: string | null;
  failure_count: number;
  disabled_at: string | null;
}

export interface NativePushListResponse {
  tokens: NativePushToken[];
  apns_enabled: boolean;
  fcm_enabled: boolean;
}

export interface NativePushRegisterBody {
  platform: NativePushPlatform;
  token: string;
  bundle_id: string;
  device_id?: string | null;
  user_agent?: string | null;
}

export interface NativePushTestResponse {
  sent: number;
  failed: number;
}

export function listTokens(): Promise<ApiResult<NativePushListResponse>> {
  return request<NativePushListResponse>("/api/push/native/tokens");
}

export function registerToken(
  body: NativePushRegisterBody,
): Promise<ApiResult<NativePushToken>> {
  return request<NativePushToken>("/api/push/native/tokens", {
    method: "POST",
    body,
  });
}

export function deleteToken(id: string): Promise<ApiResult<void>> {
  return request<void>(`/api/push/native/tokens/${id}`, {
    method: "DELETE",
  });
}

export function sendTest(): Promise<ApiResult<NativePushTestResponse>> {
  return request<NativePushTestResponse>("/api/push/native/test", {
    method: "POST",
  });
}
